import { render, staticRenderFns } from "./Recorded.vue?vue&type=template&id=2fcd6ece&"
import script from "./Recorded.vue?vue&type=script&lang=ts&"
export * from "./Recorded.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports